// components/ProfileTopics.jsx
import React from 'react';

const ProfileTopics = ({ topics, title, profileType }) => {
  if (!topics || topics.length === 0) return null;

  return (
    <div id="topic-ques" className={profileType === 'Mentee' ? 'topic-checkbox' : ''}>
      <div>
        <h3 className="pt-3">{title}</h3>
      </div>
      <ul className="d-flex">
        {topics.map(item => (
          <li key={item.id} className="topic-uncheckbox">
            {item.topic.name}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ProfileTopics;
